<template lang="pug">
.inside-padding
  form(@submit.prevent="")
    h3.capitalize Reporte de Entregas

    .input-container.arrow
      select.select(v-model="brand" autocomplete="ño" required)
        option(value="")
        option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
      label.label(:class="{ show: brand }") Marca

    sh-date-range-select(default-range="lastMonth" @change="onDateRangeChange" @display-change="onDisplayChange")

    .container-actions
      shActionButton(:isForm="true" :action="getData" text="Generar Reporte" textRunning="Generando Reporte")

  .container-report(v-if="false")
    h3.capitalize Datos Generales
    div
      span.dark Fecha:
      span  {{ dateTime(reportSales.date.initial) }} - {{ dateTime(reportSales.date.final) }}
    div
      span.dark Ordenes ({{ reportSales.docs.length }}):
      span  {{ reportSales.docs[0] ? reportSales.docs[0].order : '' }} - {{ reportSales.docs[reportSales.docs.length - 1] ? reportSales.docs[reportSales.docs.length - 1].order : '' }}
    div
      span.dark Unidades:
      span  {{ totalSales.quantity }}
    div
      span.dark Valor Vendido:
      span  {{ money(totalSales.value) }}

  .data-deliveries(v-if="deliveries.length")
    .input-container.arrow
      label.label(:class="{ show: showOnlyCod !== undefined }") Mostrar
      select.select(v-model="showOnlyCod" autocomplete="ño")
        option(:value="true") Contra Entrega
        option(:value="false") Todos
    h3.capitalize Entregas: {{ display }}
    span
    .table
      table
        thead
          tr.dark
            td Fecha orden
            td Orden
            td Ciudad
            td Conveyor
            td Guía
            td(v-if="!showOnlyCod") Valor Envío
            td(v-if="showOnlyCod") Valor Cobro
            td(v-if="showOnlyCod") Pagado
        tbody
          tr(v-for="(delivery, index) in deliveries" v-if="showOnlyCod ? delivery.charge : true")
            td {{ date(delivery.orderCreatedAt) }}
            td {{ delivery.order }}
            td {{ delivery.locationRecipient }}
            td {{ delivery.conveyor }}
            td {{ delivery.tracking }}
            td(v-if="!showOnlyCod") {{ delivery.cost }}
            td(v-if="showOnlyCod") {{ delivery.charge }}
            td(v-if="showOnlyCod") {{ delivery.charge ? delivery.isPaid : 'Sí' }}
</template>

<script>
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import shNameUser from '@/components/elements/NameUser'
import shDateRangeSelect from '@/components/helpers/DateRangeSelect'
import gqlReport from '@/graphql/report'
import gqlOrder from '@/graphql/order'
import gql from '@my/graphql'

export default {
  name: 'ReportSales',

  mixins: [mFilters, mForm],
  components: { shNameUser, shDateRangeSelect },

  data () {
    return {
      init: '',
      final: '',
      display: '',
      commissions: {},
      totalSales: { quantity: 0, value: 0 },
      brand: '',
      deliveries: [],
      showOnlyCod: false
    }
  },

  methods: {
    onDateRangeChange ({ init, final }) {
      this.init = init
      this.final = final
    },
    onDisplayChange (display) {
      this.display = display
    },
    async getData () {
      const mutation = gqlReport.GET_DELIVERIES

      const response = await gql.mutate(mutation, { initialDate: this.init, finalDate: this.final, brand: this.brand })

      if (response && response.data && response.data.getReportDeliveries) {
        this.deliveries = response.data.getReportDeliveries

        for (let i = 0; i < this.deliveries.length; i++) {
          const delivery = this.deliveries[i]

          if (delivery.charge) {
            const isPaid = await this.isPaidOrder(delivery.order, delivery.locationRecipient)
            this.$set(delivery, 'isPaid', isPaid)
          }
        }
      }
    },

    async isPaidOrder (order, location) {
      if (location === 'bogota') return 'Sí'

      const mutation = gqlOrder.GET_ALL
      const response = await gql.mutate(mutation, { search: order, searchBy: 'order', limit: 1, page: 1 })

      if (response && response.data && response.data.getOrders && response.data.getOrders.docs && response.data.getOrders.docs[0]) {
        return response.data.getOrders.docs[0].paidWholesaler ? 'Sí' : 'No'
      }
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  }
}
</script>

<style lang="stylus">
border = 1px solid rgba(0, 0, 0, .5)

.container-report, .container-commisions
  text-align left
  padding 0 1em

.container-report h3, .container-commisions h3
  margin 1em 0 .5em 0

.container-report > div, .container-commisions > div
  font-size 1.1em

.container-commisions
  margin-top 2em

.container-row-commision
  display flex

.container-row-commision
  border-top border

thead .container-row-commision
  border-top none

.container-row-commision th,
.container-row-commision td
  min-width 8em
  padding .5em

.container-row-commision th:last-child,
.container-row-commision td:last-child
  border-left border

.container-commision-table
  border border
  display inline-block
  border-radius .7em

.inside-padding
  padding-bottom 1em

.container-actions
  margin-top 1em
  display flex
  justify-content center
  gap 1em
</style>



// WEBPACK FOOTER //
// src/components/pages/reports/Deliveries.vue